import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import BrandName from './BrandName';

const RemoveBg = () => {
    const [image, setImage] = useState(null);
    const [output, setOutput] = useState(null);
    const [loading, setLoading] = useState(false);

    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setImage(acceptedFiles[0]);
            setOutput(null);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/*': [],
        },
        multiple: false,
    });

    // const handleImageChange = (e) => {
    //     setImage(e.target.files[0]);
    //     setOutput(null);
    // };

    const removeBackground = async () => {
        if (!image) return;

        const formData = new FormData();
        formData.append('image_file', image);
        formData.append('size', 'auto');

        setLoading(true);
        try {
            const res = await fetch('https://api.remove.bg/v1.0/removebg', {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Api-Key': 'YqLXoeup3mGXtRqbcRs17kt2', // Replace with your real API key
                },
            });

            if (!res.ok) throw new Error('Failed to remove background');

            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            setOutput(url);
        } catch (error) {
            console.error(error);
            alert('Failed to remove background');
        }
        setLoading(false);
    };

    return (
        <div className="container py-5">
            <div className="text-center">
                <h1 className="d-inline-flex">
                    Remove Image Background by <BrandName name="convert" />
                </h1>
                <h4>100% Automatically and Free</h4>
            </div>

            <div style={{ textAlign: 'center', marginTop: '30px' }}>
                {/* Dropzone */}
                <div
                    {...getRootProps()}
                    style={{
                        border: '2px dashed #cccccc',
                        padding: '30px',
                        borderRadius: '10px',
                        backgroundColor: isDragActive ? '#f0f8ff' : '#fafafa',
                        cursor: 'pointer',
                        marginBottom: '20px',
                        maxWidth: '500px',
                        marginInline: 'auto'
                    }}
                >
                    <input {...getInputProps()} />
                    {isDragActive ? (
                        <p>Drop the image here ...</p>
                    ) : (
                        <p>Drag & drop an image here, or click to select</p>
                    )}
                    {image && <p><strong>Selected:</strong> {image.name}</p>}
                </div>

                
                {image && (
                    <>
                      
                        <button onClick={removeBackground} disabled={loading} className='btn btn-warning mt-3'>
                            {loading ? 'Processing...' : 'Remove Background'}
                        </button>
                    </>
                )}

                <br /><br />
                {output && (
                    <div className='row justify-content-center'>
                        <div className='col-md-6'>
                            <div className='shadow rounded'>
                                <img src={output} alt="Removed Background" style={{ maxWidth: '100%' }} />
                            </div>
                            <a href={output} download="no-background.png" className='btn btn-warning mt-3'>Download PNG</a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RemoveBg;
